module.exports = __webpack_public_path__ + "img/shibai-2@2x.b127b08e.png";